import { formatDistanceToNow } from "date-fns";

/** Format a date without throwing RangeError ("Invalid time value"). */
export function safeDate(value: unknown): Date | null {
  if (!(value instanceof Date) && typeof value !== "string" && typeof value !== "number") return null;
  if (typeof value === "string" && !value.trim()) return null;
  const date = value instanceof Date ? value : new Date(value as string | number);
  return Number.isNaN(date.getTime()) ? null : date;
}

/** Prefer the updated date, then creation date; never invent a timestamp. */
export function documentRelativeTime(updatedAt: unknown, createdAt: unknown): string {
  const date = safeDate(updatedAt) ?? safeDate(createdAt);
  return date ? formatDistanceToNow(date, { addSuffix: true }) : "Date unavailable";
}

export function safeIsoString(value: unknown, fallback = ""): string {
  const date = safeDate(value);
  return date ? date.toISOString() : fallback;
}
